import React from 'react';
import Typography from '@material-ui/core/Typography';
import PortfolioTabs from '../PartialViews/portfolio-tab';
import Header from '../PartialViews/section-header';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(() => ({
    button: {
        borderRadius: "30px",
        padding: "7px 50px",
        color: "#f5deb3",
        border: "2px solid #f5deb3",
        backgroundImage: "linear-gradient(to top, rgba(245, 222, 179, 0.3), rgba(76, 142, 203, 0.6))"
    }
}))

const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector('#scroll-to-top-anchor');

    if (anchor) {
        anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
};

export default function Portfolio() {
    const classes = useStyles();
    return (
        <>
            <Header>
                <Typography variant="h2" className={`${"wow fadeInRight"}`} style={{ color: "wheat" }} gutterBottom><b>Portfolio</b></Typography>
                <Box mt={3}>
                    <Button 
                        variant="outlined" 
                        onClick={handleClick}
                        className={`${classes.button} ${"wow"} ${"rubberBand"}`} 
                        style={{animatinoDelay:"0.5s", MozAnimationDelay: "0.5s", WebkitAnimationDelay: "0.5s"}}
                        disableElevation
                        >Learn more</Button>
                </Box>
            </Header>
            <PortfolioTabs />
        </>
    )
}